module.exports = __webpack_public_path__ + "assets/deal_AYT_ls.png";